import React from "react";

import OneMovie from "../components/OneMovie";

const SingleMooviePage = () => {
  return <OneMovie  />;
};

export default SingleMooviePage;
